export const chatList = (chatListData = [], action) => {
    if (action.type === "CHAT_LIST") {
        return action.payload;
    }
    return chatListData;
};
export const activeChatUser = (chatListData = null, action) => {
    if (action.type === "ACTIVE_CHAT_LIST") {
        return action.payload;
    }
    return chatListData;
};

export const sharedData = (data = null, action) => {
    if (action.type === "SHARE_DATA") {
        return action.payload;
    }
    return data;
};
